export default __webpack_public_path__ + "static/6-2d32bca1202c2f2044713d27ebb9cc3a.svg";